import React from 'react';
import classnames from 'classnames';
import styles from './checkbox.scss';

type Props = {
  id: string,
  name: string,
  value: string,
  checked: boolean,
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean,
  className?: string,
  'data-qa-ref'?: string,
}

const unselected = (
  <rect
    x="0.5"
    y="0.5"
    width="15"
    height="15"
    rx="1.5"
    fill="white"
    stroke="#959CA4" />
);

const selected = (
  <React.Fragment>
    <rect
      width="16"
      height="16"
      rx="2"
      fill="#0078A0" />
    <path
      d="M4
      8.90518L6.95751
      12L12
      4"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round" />
  </React.Fragment>
);


export default function Checkbox({
  id,
  name,
  checked,
  onChange,
  value,
  disabled,
  className,
  ...rest
}: Props) {

  return (
    <React.Fragment>
      <input
        className={styles.realCheckbox}
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange} />

      <label htmlFor={id} className={classnames(styles.svgLabel, className)} {...rest}>
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
          {checked ? selected : unselected }
        </svg>
      </label>
    </React.Fragment>
  );
}
